import { GameNavAttrs } from "@locent/types";

import { BaseComponent } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";

/** 游戏导航组件类 */
export class GameNavComponent extends BaseComponent<
  GameNavAttrs & {
    [key: string]: string | number | boolean | object | null | undefined;
  }
> {
  constructor(
    data: Partial<
      BaseComponent<
        GameNavAttrs & {
          [key: string]: string | number | boolean | object | null | undefined;
        }
      >
    > = {},
  ) {
    super(data);
    this.type = CompType.game_nav;
  }

  /** 获取游戏导航标题 */
  public getGameNavTitle(): string {
    return this.title;
  }

  /** 设置游戏导航数据列表 */
  // public setGameNavItems(items: GameNavItem[]): void {
  //   this.setAttrs({ data_list: items });
  // }

  /** 获取指定语言的名称 */
  // public getNameByLang(item: GameNavItem, lang: string): string {
  //   return item.name_lang?.[lang] || "";
  // }

  /** 获取指定语言的URL */
  // public getUrlByLang(
  //   item: GameNavItem,
  //   lang: string,
  //   isActive: boolean = false,
  // ): string {
  //   const url = item.url_lang?.[lang];
  //   return isActive ? url?.active || "" : url?.no_active || "";
  // }
}

// 使用示例
// const gameNavData: Partial<BaseComponent<GameNavAttrs>> = {
//   id: "67dc6143d1571ca5de2dcf4f",
//   type: CompType.game_nav,
//   variant: "",
//   title: "Casino Game Navigation",
//   status: 1,
//   sort: 0,
//   login_type: LoginType.Login,
//   recharge_type: RechargeType.Recharge,
//   fixed_top: 1,
//   key: "Casino_Game_Navigation",
//   show_rtp: false,
//   height: "",
//   attrs: {
//     title_type: 1,
//     title_icon: "n-live-support",
//     data_list: [
//       {
//         click_id: 10,
//         icon_type: 1,
//         click_params: 0,
//         url_lang: {
//           "1": {
//             no_active:
//               "https://web-res-ccc.afunimg8.com/cdn-cgi/image/format=auto/dev_skin/C02/_E/home/gameEntry/temp5/sports.png",
//             active:
//               "https://web-res-ccc.afunimg8.com/cdn-cgi/image/format=auto/dev_skin/C02/_E/home/gameEntry/temp5/sports.png",
//           },
//         },
//         click_type: 0,
//         name_lang: {
//           "1": "lobby",
//         },
//         key: 1742586089020,
//         icon: "lobby",
//       },
//     ],
//   },
// };
